import { apiClient } from "@lib/axios";
import type { TSlidesFolder } from "@/shared/types";

export const slidesFolderApi = {
  getSlidesFolders: (params?: { archived?: boolean }) => {
    return apiClient.get<TSlidesFolder[]>("/slides-folder", {
      params: params?.archived ? { archived: "true" } : undefined,
    });
  },

  createSlidesFolder: (data: {
    title: string;
    parentId?: string;
  }) => {
    return apiClient.post<TSlidesFolder>("/slides-folder", data);
  },

  updateSlidesFolder: (data: {
    id: string;
    title?: string;
    parentId?: string | null;
    type?: "team-slides" | "user-slides";
    order?: number;
  }) => {
    const { id, ...updateData } = data;
    return apiClient.put<TSlidesFolder>(`/slides-folder/${id}`, updateData);
  },

  reorderSlidesFolders: (data: { parentId: string; folderIds: string[] }) => {
    return apiClient.put<{ success: boolean }>("/slides-folder/reorder", data);
  },

  archiveSlidesFolder: (id: string) => {
    return apiClient.put<{ folderIds: string[] }>(
      `/slides-folder/archive/${id}`,
    );
  },

  restoreSlidesFolder: (id: string) => {
    return apiClient.put<{ folderIds: string[] }>(
      `/slides-folder/restore/${id}`,
    );
  },

  deleteSlidesFolder: (id: string) => {
    return apiClient.delete<{ folderIds: string[] }>(`/slides-folder/${id}`);
  },
};
